import type { IsoDate } from '../../domain/dates';
import { quickAlternatives } from '../../domain/energy-swap';
import type { Recipe } from '../../domain/recipe';
import { formatDate, productList } from '../i18n/format';
import { MESSAGES, type Language } from '../i18n/messages';
import type { AppData } from '../state/app-data';
import { buildRequest, currentPlan, type EditResult } from '../state/plan-service';

// DE: Mehr Vorschläge passen nicht auf einen Blick; der Notfallvorrat steht vorn.
// EN: More suggestions do not fit at a glance; the backup kit comes first.
const MAX_CHOICES = 6;

/**
 * DE: Schnelle Ersatzgerichte für heute aus dem laufenden Plan; ohne Plan keine.
 * EN: Quick replacement dinners for today from the running plan; none without a plan.
 */
export function quickChoices(data: AppData, today: IsoDate): Recipe[] {
  const stored = currentPlan(data, today);
  if (!stored) return [];
  const request = buildRequest(data, stored);
  return quickAlternatives(stored.plan, today, request, data.pantry).slice(0, MAX_CHOICES);
}

/**
 * DE: Hinweis nach dem Tausch: neuer Tag des geplanten Gerichts oder bald zu verbrauchende Produkte.
 * EN: Notice after the swap: new day of the planned dinner or products to use soon.
 */
export function swapNotice(notice: EditResult['notice'], language: Language): string | undefined {
  const t = MESSAGES[language];
  if (notice?.movedTo) return t.movedTo(formatDate(notice.movedTo, language, 'weekday-long'));
  if (!notice?.useSoon.length) return undefined;
  return t.useSoon(productList(notice.useSoon, language));
}
